/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MonitoringWebsiteSwEnforcedTpProtocolsExportExcelRequest,
  MonitoringWebsiteSwEnforcedTpProtocolsExportExcelResponse,
  MonitoringWebsiteSwEnforcedTpProtocolsGetAllWebsiteIdsRequest,
  MonitoringWebsiteSwEnforcedTpProtocolsGetAllWebsiteIdsResponse,
  MonitoringWebsiteSwEnforcedTpProtocolsGetCountAndRecentlyListingRequest,
  MonitoringWebsiteSwEnforcedTpProtocolsGetCountAndRecentlyListingResponse,
  MonitoringWebsiteSwEnforcedTpProtocolsGetDetailsRequest,
  MonitoringWebsiteSwEnforcedTpProtocolsGetDetailsResponse,
  MonitoringWebsiteSwEnforcedTpProtocolsGetWebsitesRequest,
  MonitoringWebsiteSwEnforcedTpProtocolsGetWebsitesResponse,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class MonitoringWebsiteEnforcedTp<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags MonitoringWebsiteEnforcedTp
   * @name EnforcementWebSiteTpCountCreate
   * @request POST:/monitoring/enforcement/web-site/tp/count
   */
  enforcementWebSiteTpCountCreate = (
    data: MonitoringWebsiteSwEnforcedTpProtocolsGetCountAndRecentlyListingRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringWebsiteSwEnforcedTpProtocolsGetCountAndRecentlyListingResponse, any>({
      path: `/monitoring/enforcement/web-site/tp/count`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags MonitoringWebsiteEnforcedTp
   * @name EnforcementWebSiteTpDetailsCreate
   * @request POST:/monitoring/enforcement/web-site/tp/details
   */
  enforcementWebSiteTpDetailsCreate = (
    data: MonitoringWebsiteSwEnforcedTpProtocolsGetDetailsRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringWebsiteSwEnforcedTpProtocolsGetDetailsResponse, any>({
      path: `/monitoring/enforcement/web-site/tp/details`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags MonitoringWebsiteEnforcedTp
   * @name EnforcementWebSiteTpWebSitesCreate
   * @request POST:/monitoring/enforcement/web-site/tp/web-sites
   */
  enforcementWebSiteTpWebSitesCreate = (
    data: MonitoringWebsiteSwEnforcedTpProtocolsGetWebsitesRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringWebsiteSwEnforcedTpProtocolsGetWebsitesResponse, any>({
      path: `/monitoring/enforcement/web-site/tp/web-sites`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags MonitoringWebsiteEnforcedTp
   * @name EnforcementWebSiteTpAllWebSiteIdsCreate
   * @request POST:/monitoring/enforcement/web-site/tp/all-web-site-ids
   */
  enforcementWebSiteTpAllWebSiteIdsCreate = (
    data: MonitoringWebsiteSwEnforcedTpProtocolsGetAllWebsiteIdsRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringWebsiteSwEnforcedTpProtocolsGetAllWebsiteIdsResponse, any>({
      path: `/monitoring/enforcement/web-site/tp/all-web-site-ids`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags MonitoringWebsiteEnforcedTp
   * @name EnforcementWebSiteTpExcelCreate
   * @request POST:/monitoring/enforcement/web-site/tp/excel
   */
  enforcementWebSiteTpExcelCreate = (
    data: MonitoringWebsiteSwEnforcedTpProtocolsExportExcelRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MonitoringWebsiteSwEnforcedTpProtocolsExportExcelResponse, any>({
      path: `/monitoring/enforcement/web-site/tp/excel`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
